import { render, staticRenderFns } from "./SearchableVocaloidList.vue?vue&type=template&id=ce60fe2a&scoped=true&"
import script from "./SearchableVocaloidList.vue?vue&type=script&lang=js&"
export * from "./SearchableVocaloidList.vue?vue&type=script&lang=js&"
import style0 from "./SearchableVocaloidList.vue?vue&type=style&index=0&id=ce60fe2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce60fe2a",
  null
  
)

export default component.exports